import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NumberFormatPipe } from 'src/app/shared/pipes/number-format.pipe';
import { IconSvgComponent } from '../../icon/svg-icon.component';
import { IconsConstants } from 'src/app/shared/common';
import { CommonModule } from '@angular/common';
import { FiltersContainerComponent } from '../../filters-container/filters-container.component';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-chart-card-default-header',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    TranslateModule,
    IconSvgComponent,
    FiltersContainerComponent,
    ReactiveFormsModule
  ],
  templateUrl: './chart-card-default-header.component.html',
  styleUrls: ['./chart-card-default-header.component.scss'],
})
export class ChartCardDefaultHeaderComponent implements OnInit {
  form : FormGroup
  //inputs - outputs
  @Input() title: string;
  @Input() showReloadButton : boolean;
  @Input() showFiltersButton: boolean;
  @Input() filterSearchKey: string = 'search';
  @Input() showFiltersSearchButton: boolean = true;
  @Output() refreshChartEvent: EventEmitter<boolean> = new EventEmitter();
  //constants
  IconsConstants = IconsConstants

  constructor(private formGroupDirective : FormGroupDirective) { }

  ngOnInit(): void {
    this.form = this.formGroupDirective.form;
  }

  onRefresh(): void {
    this.refreshChartEvent.emit(true)
  }
}
